// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4K1x0","title":"styles_title__0iKOQ","sectionSubInformation":"styles_sectionSubInformation__PdJl3","sectionLogo":"styles_sectionLogo__x8US2"};
module.exports.__checksum = "6d7c357502a7"